
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[language]/program-finder",
      function () {
        return require("private-next-pages/[region]/[language]/program-finder/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[language]/program-finder"])
      });
    }
  